import axios from "@/libraries/Axios";

//get pre loved categories

export const getPreLovedCategories = () => axios.get("/category/getCategoryListLevelOne")
export const getPreLovedCategoryProducts = ({categoryId, current, size, regionId, previousProdIdList}) => axios.get("/prod/pageProdUsedProduct?categoryId="+categoryId+"&current="+current+"&size="+size+"&regionId="+regionId+"&previousProdIdList="+previousProdIdList);
export const getPreLovedProductDetails = (productId) => axios.get("/prod/usedProdInfo?prodId="+productId);